export enum LICENSE_TYPE {
  RN = 'RN',
  CRNA = 'CRNA',
  AA = 'AA',
  MD = 'MD',
  DO = 'DO',
}
export enum PROVIDER_VERIFICATION_STAGE {
  APPROVED = 'APPROVED',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  REJECTED = 'REJECTED',
}

export interface IProvider {
  id?: number;
  st_id?: string;
  verification_stage?: PROVIDER_VERIFICATION_STAGE;
  license_type?: LICENSE_TYPE;
  license_state?: string;
  aba_id?: string;
  license_number?: string;
  certificate_number?: string;
  own_malpractice_insurance?: boolean;
  insurance_company_name?: string;
  additional_info_text?: string;
  own_equipment?: boolean;
  own_drugs?: boolean;
  bio?: string;
  //Resume info
  fellowships?: string;
  fellowship_date?: Date;
  board_of_cert?: string;
  board_of_cert_date?: Date;
  board_certified?: boolean;
  residency?: string;
  residency_date?: Date;
  med_school?: string;
  med_school_date?: Date;
  college?: string;
  college_date?: Date;
  resume?: string;
  //Types of anesthesia
  general_anesthesia?: boolean;
  ob_and_delivery?: boolean;
  dental?: boolean;
  ophthalmology?: boolean;
  pediatrics_one_year?: boolean;
  pediatrics_neonatal?: boolean;
  ent?: boolean;
  trauma?: boolean;
  orthopedic_regional?: boolean;
  neurosurgery?: boolean;
  cardiac?: boolean;
  transplant?: boolean;
  pain?: boolean;
  gastro_gi?: boolean;
  other?: boolean;
  other_string?: string;

  created_at?: Date;
  updated_at?: Date;
}
